import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import DavetiyelerHub from './pages/DavetiyelerHub';
import SekerlikHub from './pages/SekerlikHub';
import CategoryListing from './pages/CategoryListing';
import ProductDetail from './pages/ProductDetail';
import NotFound from './pages/NotFound';
import DigitalInvitationPage from './pages/DigitalInvitationPage';

import { SiteProvider } from './context/SiteContext';
import { AuthProvider } from './admin/context/AuthContext';
import ProtectedRoute from './admin/components/ProtectedRoute';
import AdminLayout from './admin/components/AdminLayout';
import Login from './admin/pages/Login';
import Dashboard from './admin/pages/Dashboard';
import CategoriesPage from './admin/pages/CategoriesPage';
import ProductsPage from './admin/pages/ProductsPage';
import DigitalInvitationsPage from './admin/pages/DigitalInvitationsPage';
import DigitalInvitationFormPage from './admin/pages/DigitalInvitationFormPage';
import SettingsPage from './admin/pages/SettingsPage';
import './admin/admin.css';

function App() {
  return (
    <BrowserRouter>
      <SiteProvider>
        <AuthProvider>
          <Routes>
            <Route path="/admin/login" element={<Login />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="categories" element={<CategoriesPage />} />
              <Route path="products/:hub" element={<ProductsPage />} />
              <Route path="digital-invitations" element={<DigitalInvitationsPage />} />
              <Route path="digital-invitations/new" element={<DigitalInvitationFormPage />} />
              <Route path="digital-invitations/:id/edit" element={<DigitalInvitationFormPage />} />
              <Route path="settings" element={<SettingsPage />} />
            </Route>

            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="hakkimizda" element={<About />} />
              <Route path="davetiyeler" element={<DavetiyelerHub />} />
              <Route path="davetiyeler/:slug/:productId" element={<ProductDetail />} />
              <Route path="davetiyeler/:slug" element={<CategoryListing />} />
              <Route path="sekerlik" element={<SekerlikHub />} />
              <Route path="sekerlik/:slug/:productId" element={<ProductDetail />} />
              <Route path="sekerlik/:slug" element={<CategoryListing />} />
              <Route path="*" element={<NotFound />} />
            </Route>

            <Route path="/:slug" element={<DigitalInvitationPage />} />
          </Routes>
        </AuthProvider>
      </SiteProvider>
    </BrowserRouter>
  );
}

export default App;
